module.exports = __webpack_public_path__ + "img/smg38_samurai02skin_shop.ed44a437.png";